import { useEffect } from "react";

export default function SeoMeta({ seopages }) {
  useEffect(() => {
    if (!seopages) return;

    document.title = seopages.title || "Rankridge International School";

 // helper for canonical link
    const setCanonical = (url) => {
      if (!url) return;
      let link = document.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", url);
    };

    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.querySelector(`[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", seopages.description);
    setMeta("keywords", seopages.keywords);
    setMeta("og:title", seopages.title, "property");
    setMeta("og:description", seopages.og_description || seopages.description, "property");
    setMeta("og:image", seopages.og_image, "property");
    setMeta("og:url", seopages.canonical_path, "property");

     setCanonical(seopages.canonical_path);
  }, [seopages]);

  return null; // nothing to render, only head update
}
